export default __webpack_public_path__ + "static/media/slide4.6c17a8ed.jpeg";